import { useAuth } from "@clerk/react";
import { useQuery } from "@tanstack/react-query";

const basePath = import.meta.env.BASE_URL.replace(/\/$/, "");

export interface PlanInfo {
  plan: "free" | "pro";
  usageCount: number;
  usageLimit: number | null;
  subscriptionStatus: string | null;
  nextBillingDate: string | null;
}

export function usePlan() {
  const { getToken } = useAuth();
  return useQuery<PlanInfo>({
    queryKey: ["plan"],
    queryFn: async () => {
      const token = await getToken();
      const res = await fetch(`${basePath}/api/stripe/plan`, {
        credentials: "include",
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (!res.ok) throw new Error("Failed to fetch plan");
      return res.json();
    },
    staleTime: 60_000,
  });
}
